import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, ViewEncapsulation, ElementRef, Inject, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable ,  Subscription } from 'rxjs';
import { DialogBottomScreenComponentContent } from '@toro/common/shared/models/dialogs/dialog-bottom-screen';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { StockActions } from '@toro/common/shared/state-management/stock/stock.action';
import { FinanceActions } from '@toro/common/shared/state-management/finance/finance.action';
import { MonthsEnum } from '@toro/common/shared/enum/months.enum';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'checking-account-receipt',
    templateUrl: './checking-account-receipt.component.html',
    styleUrls: ['./checking-account-receipt.component.scss'],
})
export class CheckingAccountReceiptComponent extends DialogBottomScreenComponentContent implements OnInit, OnDestroy {
    
    public formDatePicker: FormGroup;
    public yearsInvestment: any[] = [];
    public monthsInvestment: any[] = [];
    private voucherDate: any;
    private stock$: Observable<any>;
    public monthsEnum = MonthsEnum;
    private extractDateSubscription: Subscription;
    private formSubscription: Subscription;
    public pending: boolean = false;

    constructor(
        private dialogReference : MatDialogRef<CheckingAccountReceiptComponent>, 
        element : ElementRef,
        @Inject(MAT_DIALOG_DATA) public data : any,
        private store: Store<AppState>,
        public FB: FormBuilder
    ) {
        super(element);

        // Form validate
        this.formDatePicker = this.FB.group({
            year: [ '', Validators.required ],
            month: [ '', Validators.required ]
        });

        this.extractDateSubscription = this.store.select(s => s.finance)
            .subscribe(data => {
                this.pending = data.pending;
                if(data.extractDates.length) {
                    let newArr = data.extractDates.reduce((prev: Array<any>, current) => {
                        if(prev.find(item => item.year == current.year)) {
                            const newObj = {...prev.find(item => item.year == current.year)}
                            newObj.months.push(current.month);
                            return prev;
                        } else {
                            return [...prev, { year: current.year, months: [current.month]}];
                        }
                    }, []);
                    this.yearsInvestment = newArr;
                } 
            });

        this.formSubscription = this.formDatePicker.get('year').valueChanges.subscribe(data => {
            const selectedYear = this.yearsInvestment.find(item => item.year == data);
            this.monthsInvestment = selectedYear.months.map(item => MonthsEnum[item]);
        });

        this.store.dispatch({ type: FinanceActions.getExtractDates });

    }

    /** Finaliza o componente */
    dispose(){
        super.close(this.dialogReference, null);
    }

    voucherDownload() {
        const formValue = this.formDatePicker.value;
        this.store.dispatch({ type: FinanceActions.getExtractPDF, payload: formValue });
    }

    //não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    ngOnDestroy() { }
}